
import { Outlet } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { ScrollToTop } from "../ScrollToTop";

export function RootLayout() {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <div id="scroll-sentinel" className="absolute top-0 left-0 w-full h-[50px] pointer-events-none" aria-hidden="true" />
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
